import { render, staticRenderFns } from "./NewSignupFooter.vue?vue&type=template&id=58361d49"
var script = {}
import style0 from "./NewSignupFooter.vue?vue&type=style&index=0&id=58361d49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports